import { AppleLogo } from "@phosphor-icons/react";

const BADGES = [
  { key: "cashapp", label: "Cash App", bg: "#00D632", fg: "#062e13" },
  { key: "zelle", label: "Zelle", bg: "#6D1ED4", fg: "#fff" },
  { key: "gpay", label: "GPay", bg: "#fff", fg: "#3c4043", google: true },
  { key: "applepay", label: "Pay", bg: "#000", fg: "#fff", apple: true },
];

export default function PaymentBadges({ heading = "We accept" }) {
  return (
    <div data-testid="payment-badges">
      <span className="label-mono text-muted-foreground text-[0.6rem] block mb-2 text-center">{heading}</span>
      <div className="flex flex-wrap items-center justify-center gap-1.5">
        {BADGES.map((b) => (
          <span
            key={b.key}
            data-testid={`payment-logo-${b.key}`}
            className={`px-2 py-1 rounded text-[0.6rem] font-bold tracking-wide inline-flex items-center gap-0.5 ${b.className || ""}`}
            style={{ backgroundColor: b.bg, color: b.fg, border: b.google ? "1px solid rgba(0,0,0,0.12)" : "none" }}
          >
            {b.google ? (
              <>
                <span style={{ color: "#4285F4" }}>G</span>
                <span>Pay</span>
              </>
            ) : b.apple ? (
              <>
                <AppleLogo size={11} weight="fill" />
                <span>Pay</span>
              </>
            ) : (
              b.label
            )}
          </span>
        ))}
      </div>
    </div>
  );
}
